import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Segment, Dimmer, Loader, Modal } from 'semantic-ui-react';

// Types
import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import {
    makeSelectQueryStringBooleanValue,
    makeSelectQueryStringNumberValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorGate from 'components/ErrorGate';
import LoadingGate from 'components/LoadingGate';

// Child Components
// @ts-ignore
import EventRequest from '../EventRequest';
// @ts-ignore
import EventShareUrlInput from './components/EventShareUrlInput';

interface ConnectedProps {
    open: boolean;
    selectedEvent?: number;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = ConnectedProps & DispatchProps;

export class EventShareModal extends React.PureComponent<Props> {
    handleClose = () => {
        this.props.updateQueryString({
            selectedEvent: undefined,
            eventShareModal: undefined
        });
    };

    render(): React.ReactElement | null {
        const { open, selectedEvent } = this.props;

        if (!selectedEvent) {
            return null;
        }

        return (
            <Modal
                open={open}
                onClose={this.handleClose}
                centered={false}
                size="tiny"
                closeIcon
            >
                <ErrorBoundary
                    namespace="EventShareModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <EventRequest eventId={selectedEvent} />
                    <ErrorGate namespace="EVENT_LOAD">
                        <LoadingGate
                            namespace="EVENT_LOAD"
                            LoadingComponent={
                                <Segment basic padded="very">
                                    <Dimmer active inverted>
                                        <Loader inverted />
                                    </Dimmer>
                                </Segment>
                            }
                        >
                            <Modal.Header>Share Job</Modal.Header>
                            <Modal.Content>
                                <p>
                                    Anyone can view details about this job by
                                    visiting the following link
                                </p>
                                <EventShareUrlInput eventId={selectedEvent} />
                            </Modal.Content>
                        </LoadingGate>
                    </ErrorGate>
                </ErrorBoundary>
            </Modal>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    open: makeSelectQueryStringBooleanValue('eventShareModal'),
    selectedEvent: makeSelectQueryStringNumberValue('selectedEvent')
});

export default connect(mapStateToProps, { updateQueryString })(EventShareModal);
